import { createIcon } from '../icon'
import EyeOnIcon from '../svg/EyeOnIcon'

export const EyeOnIconDefault = createIcon(EyeOnIcon)
